module.exports = __webpack_public_path__ + "img/icon_3_24.b5cbadea.png";